<template>
  <div class="conflict-list" :class="{'without_btn': !(!isTherapist && !onlyList && !isMensurationForbidden)}">

    <table-view
        :options="options"
        :isLoaded=isLoaded
        :isChange="isChange"
        v-on:on-search="onSearchEnter"
    >
      <div slot="id" slot-scope="props">
        <router-link
            :to="{ name: 'conflict-list', params: {clientId: clientId, sessionId: props.row.id }}">
          <div class="icon-circle icon-blue"><span v-if="!isMobile">{{props.row.id}}</span></div>
        </router-link>
      </div>

      <div slot="protocols" slot-scope="props">

        <router-link :to="{ name: 'conflict-list', params: {clientId: clientId, sessionId: props.row.id }}" class="title">
          <strong>{{props.row.title}}</strong>
        </router-link>
        <!--<strong v-if="!onlyList">{{protocol.protocol.title}}<br></strong>-->
      </div>

      <div slot="stageIndex" slot-scope="props">
        {{props.row.stageIndex + 1}}
      </div>

      <div slot="action" slot-scope="props" v-if="!isTherapist && !isClient">

        <a href="#"
           class="delete-icon"
           @click.prevent="showDeletePopup(props.row.id)">
          <mdc-icon icon="delete"></mdc-icon>
        </a>
      </div>

    </table-view>

    <mdc-dialog v-model="isDeleteModalVisible"
                :title="'user.confirm_delete' | trans"
                :accept="'user.delete' | trans"
                :cancel="'user.cancel' | trans"
                @accept="onRemoveActiveProtocol(assignedSessionId)"
                @cancel="onModalClose">

    </mdc-dialog>

  </div>

</template>

<script>
  import axios from 'axios';
  import lang from '../../../../lang/translator';
  import isEmpty from 'lodash/isEmpty';
  import Loader from '../../../loader/components/Loader';
  import {pagination} from '../../../../common/mixins/pagination';
  import {showModal} from '../../../../common/mixins/showModal';
  import {mapActions, mapGetters} from 'vuex';
  import {PROTOCOL_STATUSES} from '../../../protocols/constants.js';
  import TableView from '../../../../common/table/components/TableView';
  import moment from 'moment';

  export default {
    name: 'ClientInfo',
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'onlyList': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'reload': {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        protocolUrl: '/protocols/users/',
        conflictedUrl: '/protocols/assigned/',
        conflictedProtocols: [],
        isLoaded: true,
        isDeleteModalVisible: false,
        assignedSessionId: null,
        isChange: false,
        options: {
          initialPage: null,
          filterable: false,
          sortable: [],
          skin: 'table table-sm',
          withSearch: true,
          columns: [
            {
              key: 'id',
              changed: true,
              headings: lang.get('protocol.protocols')
            },
            {
              key: 'protocols',
              changed: true,
              headings: ''
            },
            {
              key: 'createdAt',
              changed: false,
              headings: lang.get('protocol.save_session_date'),
            },
            {
              key: 'startedAt',
              changed: false,
              headings: lang.get('protocol.start_session_date')
            },
            {
              key: 'stimuliCount',
              changed: false,
              headings: lang.get('protocol.trial_count')
            },
            {
              key: 'stageIndex',
              changed: true,
              headings: lang.get('protocol.stage_count')
            },
            {
              key: 'action',
              changed: true,
              headings: ''
            }
          ],
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts:{
            filterPlaceholder: lang.get('bids.type_the_procol_name_to_search'),
            noResults:lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table')
          },
          columnsClasses:{
            id: 'action-cell',
            stageIndex: 'text-center',
            stimuliCount: 'text-center',
            startedAt: 'text-center nowrap',
            createdAt: 'text-center nowrap',
            action:'table-actions'
          },
          templates: {
            startedAt: this.startedAt,
            createdAt:this.createdAt,
          },
          toMomentFormat: ['updatedAt', 'createdAt'],
          perPage: 10,
          columnsDisplay: {
            id: 'min_tabletL',
            startedAt: 'min_tabletL',
            createdAt: 'min_tabletL',
          }
        },
        search: ''
      };
    },

    mixins: [pagination, showModal],

    components: {
      Loader, TableView
    },

    computed: {
      isEmptyProtocols: function() {
        return isEmpty(this.conflictedProtocols);
      },
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'isTherapist',
        'isCurator',
        'isClient',
        'isBCBA',
        'isMensurationForbidden',
      ]),
    },

    mounted() {

      if(localStorage.currentConflictPage){
        this.options.initialPage = localStorage.getItem("currentConflictPage");
      }
      this.options.initialPage = this.options.initialPage ? this.options.initialPage : 1;

      console.info(this.options.initialPage);

    },

    beforeDestroy(){
      localStorage.removeItem('currentConflictPage');
    },

    methods: {

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      startedAt(h, row) {
        return this.toLocaleDate(row.startedAt.date);
      },

      createdAt(h, row) {
        return this.toLocaleDate(row.createdAt.date);
      },

      async requestFunction (data) {
        return this.getConflictedProtocols(this.options.perPage, data.page, this.clientId, data.query);
      },

      isNew: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.NEW;
      },

      isActive: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.ACTIVE;
      },

      isMaintaining: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.MAINTAINING;
      },

      isCompleted: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.COMPLETED;
      },

      isDTT: function(protocol) {
        return protocol.protocol.teachingMethod.id === 1;
      },

      getConflictedProtocols: async function(perPage, page, clientId, search) {
        try {
          this.isLoaded = false;
          localStorage.setItem('currentConflictPage', page);
          search = search  ? search : this.search;
          let params = {
              sort: this.sort
          };
          if(search) {
            params.search = search;
          }
          let response = await axios.get(
              `${this.conflictedUrl}${clientId}/inconsistent/sessions/${perPage}/${page}`, {
                params: params
              });

          this.conflictedProtocols = response.data.data.items;
          this.isLoaded = true;
          if (!isEmpty(this.conflictedProtocols)) {
            this.setPaginate(response.data.data);
          }

          return response;
        } catch (error) {
          console.dir(error);
        }
      },

      showDeletePopup(id) {
        this.assignedSessionId = id;
        this.isDeleteModalVisible = true;
        this.isChange = false;
      },

      onRemoveActiveProtocol: async function(sessionId) {
        try {
          this.isLoaded = false;
          let isDeleted = await axios.delete(this.conflictedUrl + this.clientId + '/inconsistent/sessions/' + sessionId);
          if (isDeleted) {
            this.getConflictedProtocols(this.paginate.perPage, this.paginate.page,
                this.clientId);
            this.isLoaded = true;
            this.isChange = true;
          }

        } catch (error) {
          console.dir(error);
        }
      },

      onPaginationClick: async function(pageNum) {
        this.getConflictedProtocols(this.paginate.perPage, pageNum,
            this.clientId);
        this.onPaginationBtnClick(pageNum);
      },

      onSearchEnter: function (search) {
        this.search = search;
        this.paginate.page = 1;
      },
    },
    watch: {
      reload: function(newVal) {
        if (newVal) {
          this.isChange = false
          let response = this.getConflictedProtocols(this.paginate.perPage, this.paginate.page,
              this.clientId);

          if (response){
            this.isChange = true;
          }
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/user/client/components/ConflictProtocolList.vue